module.exports = __webpack_public_path__ + "img/00014.7a88c0fc.webp";